import { DateRangeView } from '@components/organisms/date-range-view/date-range-view';
import type { BaseDate, DateRangeOptions } from '@components/organisms/date-range-view/date-range-view-types';
import type { CellContext } from '@tanstack/react-table';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';

export interface DataGridDateRangeCell {
	startDate: BaseDate[] | BaseDate;
	endDate: BaseDate[] | BaseDate;
	// Optional details to display below the date range
	details?: string[][] | string[];
}

export function getColumnDefDateRange<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function DateRangeCell(context: CellContext<T, unknown>) {
		const value = context.getValue() as DataGridDateRangeCell;
		const { startDate, endDate, details } = value;
		const dateRangeOptions = col.options as DateRangeOptions;
		const row = context.row.original;

		const parsed = options?.parse?.(value, row, options);

		return (
			<DateRangeView
				startDate={startDate}
				endDate={endDate}
				details={details}
				timezone={options.timezone}
				locale={options.locale}
				parsed={parsed}
				dateRangeOptions={dateRangeOptions}
			/>
		);
	};
}
